import './youngs/style';
import FormStructure from './youngs/form_structure';

export default FormStructure;